const listeners = [];

const addListener = cb => {
    const index = listeners.push(cb);
    return () => listeners.splice(index - 1, 1);
}

window.addEventListener('scroll', () => {
    listeners.forEach(cb => cb((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 150))
})

export default {
    data: () => ({
        scrollBottom: false,
        scrollUnsubscribe: null
    }),
    mounted() {
        this.scrollUnsubscribe = addListener((flag) => {
            console.log(flag)
            this.scrollBottom = flag
        });
    },
    destroyed() {
        this.scrollUnsubscribe();
    }
}